"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBatchMutation = void 0;
var react_1 = require("react");
var INITIAL_STATE = { response: [], loading: false, error: null };
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useBatchMutation(method, onSuccess, onError) {
    var _this = this;
    var _a = react_1.useState(INITIAL_STATE), result = _a[0], setResult = _a[1];
    var _b = react_1.useState([]), invocations = _b[0], setInvocations = _b[1];
    var invoke = react_1.useCallback(function (params) { return __awaiter(_this, void 0, void 0, function () {
        var response, result_1, error_1, result_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Each successive invocation is cause for resetting to initial state + loading.
                    setResult(function () { return (__assign(__assign({}, INITIAL_STATE), { loading: true })); });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Promise.all(params.map(method))];
                case 2:
                    response = _a.sent();
                    result_1 = { response: response, error: null, loading: false };
                    setResult(function () { return result_1; });
                    setInvocations(function (prevInvocations) { return prevInvocations.concat(result_1); });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    result_2 = { error: error_1, response: [], loading: false };
                    setResult(function () { return result_2; });
                    setInvocations(function (prevInvocations) { return prevInvocations.concat(result_2); });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [method]);
    react_1.useEffect(function () {
        var _a;
        if (onSuccess && invocations.length > 0 && ((_a = result.response) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            onSuccess(result.response);
        }
        // Only trigger effect when invocation list updates!
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [invocations.length]);
    react_1.useEffect(function () {
        if (onError && invocations.length > 0 && result.error) {
            onError(result.error);
        }
        // The only reason this effect should re-run is because the invocation list changes!
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [invocations.length]);
    return {
        result: result,
        invoke: invoke,
        invocations: invocations,
        reset: function () {
            setResult(INITIAL_STATE);
            setInvocations([]);
        }
    };
}
exports.useBatchMutation = useBatchMutation;
